// My Deck Runith Over (§31 A11): the House of Cards and the Unrelenting
// Knuckles of Brass.
//
// - **The blow**: the bearer's `blowOf` is `ARTIFACTS_LATE.brass` higher while
//   powered — `Position.brass` (the artifact mirror), by body.
// - **The cards**: each House counts its side's factory ticks while powered
//   (`tallyHouseTicks`, in `runMachines`); here, at the end of the command,
//   every `ARTIFACTS_LATE.houseTicks` of them pays one trophy — the design's
//   "card reward with the typical choice between three cards" is A2's
//   trophy, claimed or kept by the same commands. Only the run's side has a
//   hand: a count that fills for any other side is dropped.

import type { GameState } from "../commands";
import { gearOf, gearPowered } from "../industry/gear";
import { cloneIndustry, HOUSE_OF_CARDS, structureAt } from "../industry/state";
import { ARTIFACTS_LATE } from "../rules";
import { withTrophies } from "./deck";

/** Squares of the Houses whose count has filled, ascending. */
function filled(state: GameState): number[] {
  const out: number[] = [];
  for (const [sq, structure] of state.industry.structures) {
    if (structure.kind === HOUSE_OF_CARDS && (structure.dealt ?? 0) >= ARTIFACTS_LATE.houseTicks) out.push(sq);
  }
  return out.sort((a, b) => a - b);
}

/** Pay every filled House of Cards' card rewards. Returns `next` itself when none filled. */
export function payHouseOfCards(state: GameState, next: GameState): GameState {
  const squares = filled(next);
  if (squares.length === 0) return next;
  const industry = next.industry.structures === state.industry?.structures ? cloneIndustry(next.industry) : next.industry;
  let run = next.run;
  for (const sq of squares) {
    const house = structureAt(industry, sq)!;
    const dealt = house.dealt ?? 0;
    const rewards = Math.floor(dealt / ARTIFACTS_LATE.houseTicks);
    const rest = dealt % ARTIFACTS_LATE.houseTicks;
    const left = { ...house };
    if (rest > 0) left.dealt = rest;
    else delete left.dealt;
    industry.structures.set(sq, left);
    const gear = gearOf(industry).find((one) => one.anchor === sq && gearPowered(industry, one));
    if (run && gear && gear.side === run.side) run = withTrophies(run, next.seed, rewards);
  }
  return { ...next, industry, run };
}

/** Own ticks the House on `sq` has counted toward its next card (inspector). */
export const houseTicksAt = (state: GameState, sq: number): number => structureAt(state.industry, sq)?.dealt ?? 0;
